import { useSeo } from "../hooks/useSeo";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../lib/motionx";
import { site } from "../data/site";
import { useLang } from "../i18n";

const points = [
  "We aim to meet WCAG 2.1 AA guidelines across the site.",
  "Color combinations are chosen for readable contrast.",
  "The site is keyboard-navigable with visible focus indicators.",
  "Images include descriptive alternative text.",
  "Form fields have clear, associated labels.",
  "Motion respects the 'reduce motion' system preference.",
];

export default function Accessibility() {
  const { t } = useLang();
  useSeo({
    title: "Accessibility Statement | Amenity Health Services",
    description: "Amenity Health Services is committed to an accessible, ADA-conscious website experience for all visitors.",
  });

  return (
    <>
      <PageHeader
        label="Accessibility"
        titleLines={["Accessibility", "Statement"]}
        intro="We are committed to making this website welcoming and usable for everyone, including people with disabilities."
      />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 space-y-6">
          <Reveal>
            <p className="text-ink/65 leading-relaxed">
              {t("Amenity Health Services strives to ensure our website is accessible and ADA-conscious. The following reflects our ongoing commitment (edit as your practices are confirmed):")}
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <ul className="space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 rounded-2xl border border-black/5 bg-white px-5 py-4 text-ink/75">
                  <span className="mt-1.5 h-2 w-2 rounded-full bg-teal shrink-0" />
                  {t(p)}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-3xl bg-sage/20 p-7">
              <h2 className="font-heading font-semibold text-lg text-ink">{t("Need help or found a barrier?")}</h2>
              <p className="mt-2 text-ink/65 leading-relaxed">
                {t("If you experience any difficulty using this site, please contact us at")}{" "}
                <a href={`mailto:${site.email}`} className="text-teal underline underline-offset-2">{site.email}</a> {t("or")}{" "}
                <a href={site.phoneHref} className="text-teal underline underline-offset-2">{site.phone}</a> {t("and we'll be glad to assist.")}
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
